import type { EventData } from '@/lib/analytics/umami-client';
import type { DeviceHealth } from '@/features/notifications/lib/deviceHealth';

const LAST_REPORTED_KEY = 'push.health.lastReported';

let lastReportedInMemory: string | null = null;

export function notificationHealthPayload(input: {
  platform: string;
  healthState: string | null;
  health: DeviceHealth;
}): EventData {
  const payload: EventData = {};
  const put = (key: string, value: string | number | boolean | undefined): void => {
    if (value !== undefined) payload[key] = value;
  };
  put('platform', input.platform);
  put('appVersion', input.health.appVersion);
  put('healthState', input.healthState ?? 'unknown');
  put('permission', input.health.permission);
  put('channelImportance', input.health.channelImportance);
  put('channelSound', input.health.channelSound);
  put('iosAuthorization', input.health.iosAuthorization);
  put('iosAlertStyle', input.health.iosAlertStyle);
  put('iosSound', input.health.iosSound);
  put('iosLockScreen', input.health.iosLockScreen);
  put('iosNotificationCenter', input.health.iosNotificationCenter);
  put('iosTimeSensitive', input.health.iosTimeSensitive);
  put('iosScheduledSummary', input.health.iosScheduledSummary);
  put('channelVisibility', input.health.channelVisibility);
  put('androidNotificationsEnabled', input.health.androidNotificationsEnabled);
  put('androidInterruptionFilter', input.health.androidInterruptionFilter);
  put('androidAlertsBypassDnd', input.health.androidAlertsBypassDnd);
  put('androidRingerMode', input.health.androidRingerMode);
  put('androidBackgroundRestricted', input.health.androidBackgroundRestricted);
  put('androidIgnoringBatteryOptimizations', input.health.androidIgnoringBatteryOptimizations);
  put('androidStandbyBucket', input.health.androidStandbyBucket);
  return payload;
}

export function claimHealthReport(
  payload: EventData,
  storage: Pick<Storage, 'getItem' | 'setItem'> | undefined,
): boolean {
  const serialized = JSON.stringify(payload);
  try {
    if (!storage) throw new Error('no storage');
    if (storage.getItem(LAST_REPORTED_KEY) === serialized) return false;
    storage.setItem(LAST_REPORTED_KEY, serialized);
    return true;
  } catch {
    if (lastReportedInMemory === serialized) return false;
    lastReportedInMemory = serialized;
    return true;
  }
}
